import { useContactFormMutation } from 'src/api/mutations';
import { useToast } from '@chakra-ui/react';

interface ContactFormHookData {
  name: string;
  email: string;
  company: string;
  message: string;
}

export const useContactForm = () => {
  const toast = useToast();
  const contactMutation = useContactFormMutation({
    onSuccess: () => {
      toast({
        title: 'Message sent successfully!',
        description: "We'll get back to you within 24 hours.",
        status: 'success',
        duration: 5000,
        isClosable: true,
        variant: 'solid',
      });
    },
    onError: () => {
      toast({
        title: 'Error sending message',
        description:
          'Please try again or contact us directly at support@merkatus.io',
        status: 'error',
        duration: 5000,
        isClosable: true,
        variant: 'solid',
      });
    },
  });

  const submitContactForm = async (data: ContactFormHookData) => {
    try {
      await contactMutation.mutateAsync({
        firstName: data.name.split(' ')[0] || data.name,
        lastName: data.name.split(' ').slice(1).join(' ') || '',
        email: data.email,
        company: data.company,
        phone: '',
        message: data.message,
        interest: 'demo',
      });

      return { success: true };
    } catch (error) {
      // Error toast is already handled by onError callback
      return { success: false, error };
    }
  };

  return {
    submitContactForm,
    isLoading: contactMutation.isLoading,
    isError: contactMutation.isError,
    error: contactMutation.error,
  };
};
